import React from "react";
import "../../index.css";

const downloadsData = [
  {
    title: "JRIIT- ALMANAC 2025/2026",
    link: "#",
    buttonText: "Download Form",
  },
  {
    title: "JRIIT- PROSPECTUS 2025/2026",
    link: "#",
    buttonText: "Download Form",
  },
  {
    title: "NACTE CALENDAR 2025/2026",
    link: "#",
    buttonText: "Download Form",
  },
  {
    title: "DIPLOMA AND CERTIFICATE APPLICATION FORM",
    link: "https://apply.jrsys.ac.tz/",
    buttonText: "Apply Now",
  },
  {
    title: "SHORT COURSE APPLICATION FORM",
    link: "https://docs.google.com/forms/d/e/1FAIpQLScAO1TfkluVx9t_BeUHBwuA7ZIqxdUJqJwocVx7vAWAtTuc7w/viewform?usp=header",
    buttonText: "Apply Now",
  },
];

const QuickDownloads = () => {
  return (
    <section className="bg-gray-100 pb-10 pt-8">
      {/* Header with blinking effect */}
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-custom-pink mb-4 blink">
          QUICK APPLICATION & DOWNLOADS
        </h2>
        <span className="inline-block border-solid border-b-4 border-gold mb-4 w-20 sm:w-28 h-2 blink"></span>

        <p className="text-lg sm:text-xl text-gray-600 mb-8">
          Access all important documents and forms you need to apply and plan
          for your journey at JRIIT.
        </p>
      </div>

      {/* Downloads */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center">
        {downloadsData.map((item, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300"
          >
            <div className="flex flex-col items-start">
              <h3 className="text-xl font-semibold mb-2 text-gray-800">
                {item.title}
              </h3>
              <a
                href={item.link}
                target="_blank"
                download={item.link !== "#" ? true : false}
                className="inline-block bg-custom-pink text-white py-2 px-4 rounded-lg hover:bg-gold transition-colors duration-300"
                rel="noreferrer"
              >
                {item.buttonText}
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default QuickDownloads;
